import './css/site.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as Chartkick from 'chartkick';
import App from './App';
var CHARTKICK = 'Chartkick';
Chartkick.default.configure({ language: 'hu' });
window[CHARTKICK] = Chartkick.default;
ReactDOM.render(React.createElement(App, null), document.getElementById('app'));



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 317
// module chunks = 0